(() => {
  const popup = document.querySelector('[data-volume-popup]');
  if (!popup) return;
  const dialog = popup.querySelector('.volume-popup__dialog');
  let previousFocus = null;
  let timer;
  const media = popup.querySelector('video');
  const frame = popup.querySelector('iframe[data-video-src]');
  const status = popup.querySelector('[data-volume-status]');
  const startMedia = () => {
    if (frame && !frame.src) frame.src = frame.dataset.videoSrc;
    if (media) {
      media.preload = 'auto';
      if (media.readyState === 0) media.load();
      media.play().catch(() => {});
    }
  };
  const stopMedia = () => {
    if (media) media.pause();
    if (frame?.src) { frame.dataset.videoSrc = frame.src; frame.removeAttribute('src'); }
  };
  const open = () => {
    if (document.documentElement.classList.contains('account-popup-open')) {
      timer = window.setTimeout(open, 1800);
      return;
    }
    previousFocus = document.activeElement;
    popup.hidden = false;
    requestAnimationFrame(() => {
      popup.classList.add('is-open');
      document.documentElement.classList.add('volume-popup-open');
      dialog.focus({ preventScroll: true });
      startMedia();
    });
  };
  const close = () => {
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('volume-popup-open');
    stopMedia();
    window.setTimeout(() => { popup.hidden = true; if (previousFocus?.focus) previousFocus.focus(); }, 440);
  };
  popup.querySelectorAll('[data-volume-close]').forEach((button) => button.addEventListener('click', close));
  popup.querySelectorAll('[data-volume-tier]').forEach((button) => button.addEventListener('click', async () => {
    const primaryId = Number(button.dataset.primaryVariant);
    const secondaryId = Number(button.dataset.secondaryVariant);
    const bundleSize = Number(button.dataset.bundleSize);
    if (!primaryId || !secondaryId || ![2, 3].includes(bundleSize)) return;
    const buttons = [...popup.querySelectorAll('[data-volume-tier]')];
    buttons.forEach((item) => { item.disabled = true; });
    if (status) status.textContent = `Adding ${bundleSize} items to your cart…`;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          { id: primaryId, quantity: bundleSize === 3 ? 2 : 1 },
          { id: secondaryId, quantity: 1 }
        ] })
      });
      if (!response.ok) throw new Error('Unable to add bundle');
      window.location.assign('/cart');
    } catch (error) {
      if (status) status.textContent = 'We could not add the bundle. Please try again.';
      buttons.forEach((item) => { item.disabled = false; });
    }
  }));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && popup.classList.contains('is-open')) close(); });
  timer = window.setTimeout(open, Number(popup.dataset.delay || 7000));
  document.addEventListener('shopify:section:load', () => { if (!popup.classList.contains('is-open')) open(); });
})();
